import React from 'react';
import { useLocation } from 'react-router-dom';

import { Card, Title, Description } from './MembershipConfirmationCard.styled';
import membership from 'assets/icons/membership.svg';
import { YellowButton } from 'components/Buttons/Buttons';

interface Props {
  onClick: () => void;
  id?: string;
}

const DEFAULT_TITLE = 'Kindbody Member';

interface LocationState {
  title?: string;
}

export const MembershipConfirmationCard = ({ onClick, id }: Props) => {
  const location = useLocation();
  const title = (location.state as LocationState)?.title || DEFAULT_TITLE;

  return (
    <Card id={id}>
      <img src={membership} alt="" />
      <Title>{title}</Title>
      <Description>Ready to take advantage of your membership benefits?</Description>
      <YellowButton onClick={onClick}>Book an appointment</YellowButton>
    </Card>
  );
};
